import { useQuery } from '@apollo/client';
import { USEFUL_GUIDE } from 'apolloClient/queries/usefulGuide';
import { UsefulGuideResponse } from 'apolloClient/types/UsefulGuide';

export function useUsefulGuide(): {
  usefulGuide: UsefulGuideResponse | null;
  loading: boolean;
} {
  const { data, loading, error } = useQuery<{
    usefulGuide: UsefulGuideResponse;
  }>(USEFUL_GUIDE);

  if (error) {
    console.error(
      '[useUsefulGuide] Failed to fetch useful guide:',
      error.message
    );
  }

  return {
    usefulGuide: data?.usefulGuide ?? null,
    loading,
  };
}
